var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBgShapeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 1035,
    viewBox: "0 0 611 1035",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.739 893.941C251.622 1009.49 414.91 1033.54 530.457 947.653C605.873 891.599 645.791 796.896 633.364 703.759C626.003 648.561 597.863 610.701 570.676 563.683C488.302 421.126 417.65 231.634 509.087 76.0011C535.974 30.2621 432.603 65.4526 417.192 70.9523C111.576 180.146 -31.5965 540.199 123.722 828.041C136.102 851.002 150.172 873.027 165.735 893.965L165.739 893.941Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.217 878.393C258.189 988.678 414.041 1011.63 524.327 929.658C596.308 876.157 634.407 785.774 622.54 696.862C615.504 644.154 588.657 608.063 562.714 563.152C484.094 427.093 416.638 246.21 503.945 97.6889C529.587 54.0357 430.944 87.6041 416.234 92.8618C124.544 197.102 -12.1153 540.725 136.131 815.465C147.949 837.381 161.378 858.4 176.22 878.369L176.217 878.393Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.695 862.843C264.756 967.866 413.173 989.724 518.196 911.663C586.744 860.714 623.025 774.626 611.738 689.993C605.046 639.802 579.475 605.428 554.769 562.672C479.906 433.086 415.664 260.865 498.795 119.424C523.217 77.8603 429.274 109.827 415.266 114.843C137.48 214.101 7.35552 541.323 148.553 802.964C159.813 823.812 172.598 843.847 186.74 862.874L186.695 862.843Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.198 847.297C271.347 947.058 412.329 967.82 512.09 893.671C577.203 845.275 611.665 763.507 600.939 683.1C594.591 635.426 570.273 602.766 546.827 562.168C475.719 439.079 414.696 275.471 493.674 141.139C516.875 101.665 427.632 132.03 414.329 136.779C150.472 231.059 26.8779 541.905 160.982 790.416C171.68 810.218 183.824 829.247 197.243 847.329L197.198 847.297Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.673 831.772C277.911 926.271 411.433 945.934 505.932 875.697C567.611 829.852 600.253 752.404 590.084 676.248C584.057 631.088 561.039 600.148 538.809 561.678C471.431 445.082 413.65 290.116 488.452 162.864C510.433 125.479 425.894 154.218 413.292 158.726C163.363 248.028 46.2798 542.468 173.311 777.876C183.448 796.634 194.947 814.68 207.669 831.796L207.673 831.772Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.152 816.223C284.478 905.459 410.565 924.028 499.802 857.701C558.046 814.41 588.868 741.281 579.261 669.351C573.579 626.708 551.837 597.485 530.843 561.17C467.219 451.071 412.655 304.743 483.282 184.571C504.047 149.252 424.228 176.417 412.304 180.679C176.304 265.003 65.7302 543.038 185.688 765.344C195.264 783.058 206.098 800.093 218.124 816.243L218.152 816.223Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.63 800.673C291.045 884.648 409.697 902.121 493.671 839.706C548.482 798.967 577.483 730.158 568.462 662.457C563.124 622.332 542.655 594.85 522.902 560.667C463.031 457.065 411.687 319.35 478.164 206.262C497.684 173.028 422.59 198.595 411.371 202.591C189.271 281.958 85.232 543.592 198.121 752.771C207.111 769.436 217.329 785.468 228.654 800.677L228.63 800.673Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239.108 785.124C297.613 863.836 408.829 880.215 487.541 821.711C538.917 783.524 566.102 719.01 557.635 655.585C552.618 617.973 533.449 592.212 514.936 560.159C458.82 463.054 410.693 333.977 472.994 227.97C491.294 196.825 420.903 220.767 410.386 224.521C202.214 298.909 104.686 544.138 210.505 740.191C218.934 755.811 228.51 770.837 239.112 785.1L239.108 785.124Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.607 769.603C304.2 843.053 407.981 858.336 481.431 803.743C529.373 768.11 554.738 707.915 546.832 648.716C542.16 613.621 524.267 589.578 506.99 559.68C454.628 469.072 409.718 348.632 467.844 249.706C484.924 220.65 419.233 242.991 409.417 246.503C215.175 315.913 124.18 544.74 222.903 727.687C230.77 742.263 239.705 756.281 249.611 769.579L249.607 769.603Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.086 754.054C310.768 822.241 407.113 836.43 475.277 785.745C519.784 752.664 543.329 696.789 536.006 641.843C531.654 609.262 515.062 586.939 499.021 559.197C450.413 475.086 408.723 363.26 462.695 271.441C478.558 244.451 417.564 265.214 408.477 268.463C228.163 332.895 143.675 545.342 235.328 715.162C242.634 728.694 250.929 741.705 260.11 754.057L260.086 754.054Z",
    stroke: "#DD9326",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBgShapeOrange);
export default __webpack_public_path__ + "static/media/products_bg_shape_orange.43b291b4b9482ec3bc8edd1d986816ce.svg";
export { ForwardRef as ReactComponent };